<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <div class="flex justify-center flex-wrap grey-bg">
        <div class="md-col-12 lg-col-6 flex flex-wrap justify-between p2 text-center">
          {{ getReferencelabel("DISCONTINUED_KEZIA_WALLET") }}
        </div>
        <div
          v-for="(wallet, walletIndex) in wallets"
          :id="wallet.uuid"
          :key="walletIndex"
          class="col-8 lg-col-12 xs-hide sm-hide flex justify-center m3 white-bg"
        >
          <div class="md-col-12 lg-col-6 flex flex-wrap justify-between p2">
            <span class="col-12 center"> {{ getReferencelabel("SCANN_QRCODE") }} </span>
            <div class="flex flex-column items-end col-5">
              <h2 class="m0 mt2">{{ wallet.holder.lastname }} {{ wallet.holder.firstname }} </h2>
              <h3 v-if="wallet.center">{{ getCenterName(wallet.center) }}</h3>
            </div>
            <div v-if="wallet.kezia_id" class="col-6 flex justify-start white-bg mt1">
              <div class="pointer" style="width:120px" @click="openModal(wallet.kezia_id)" v-html="generateQRcode(wallet.kezia_id)"> </div>
            </div>
            <div class="col-12 flex justify-center pb3">
              <span class="pt1 dark-grey" style="font-size: 13px">
                {{ getReferencelabel("PRESS_QRCODE_TO_OPEN") }} </span>
            </div>

            <div
              v-for="(action, actionIndex) in actions"
              :key="actionIndex"
              class="col-12 table py2 m1 border"
            >
              <router-link class="table-cell pl2" :to="{ name: action.pathName, params: { id: wallet.uuid } }">{{ getReferencelabel(action.reference) }}</router-link>
              <i class="icon-chevron-right table-cell align-middle right-align pr2">
              </i>
            </div>
          </div>
        </div>

        <!-- MOBILE -->
        <div class="col-12 md-hide lg-hide">
          <Carousel :items-to-show="1.1" :wrap-around="false">
            <Slide
              v-for="(wallet, walletIndex) in wallets"
              :id="walletIndex"
              :key="walletIndex"
              class="px2 pt3"
              :style="wallets.length === 1 ? 'width: 100vw' : 'width: 90vw' "
            >
              <div class="white-bg" style="border-radius: 10px;">
                <div class="p1 pt2">
                  <span> {{ getReferencelabel("SCANN_QRCODE") }} </span>

                  <div class="col-12 flex flex-wrap justify-center p2">
                    <div class="col-6 flex flex-wrap items-center justify-center">
                      <h2 class="col-12 m0">
                        {{ wallet.holder.lastname }} {{ wallet.holder.firstname }}
                      </h2>
                      <h4 v-if="wallet.center" class="col-12 m0">{{ getCenterName(wallet.center) }}</h4>
                    </div>

                    <div v-if="wallet.kezia_id" class="col-6 flex justify-end pointer" @click="openModal(wallet.kezia_id)">
                      <div style="width:100px" v-html="generateQRcode(wallet.kezia_id)"> </div>
                    </div>

                    <span class="pt1 center dark-grey" style="font-size: 13px">
                      {{ getReferencelabel("PRESS_QRCODE_TO_OPEN") }}
                    </span>

                    <div v-for="(action, actionIndex) in actions" :key="actionIndex" class="col-12 table p1 mt1 border">
                      <router-link
                        style="font-size:14px;"
                        class="table-cell pl2"
                        :to="{ name: action.pathName, params: { id: wallet.uuid }}"
                      >
                        {{ getReferencelabel(action.reference) }}
                      </router-link>
                      <i class="icon-chevron-right table-cell align-middle right-align pr2">
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </Slide>

            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>

        <!-- MODAL  -->
        <Modal v-if="showModal">
          <template #body>
            <div class="col-12 flex flex-wrap justify-center white-bg modal-qrcode-dimensions">
              <div class="flex flex-wrap justify-center  px1">
                <div class="col-12 center">
                  <span>{{ getReferencelabel("QRCODE_PERSONAL_PAYMENT") }} </span>
                  <span>{{ getReferencelabel("NOT_SHARE_QRCODE") }} </span>
                </div>
                <div class="py4" style="width:300px" v-html="selectedQRCode"> </div>
                <span class="col-12 center  dark-grey pt2"> {{ getReferencelabel("DOUBLE_TAP_TO") }} </span>
              </div>
            </div>
          </template>
        </Modal>
      </div>
    </template>
    <router-view v-else />
  </div>
</template>
<script>

import { Carousel, Slide, Pagination } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

import { computed, provide, ref, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Modal from '@/components/blocks/Modal';
import { menuHandler, generateQRcode, getCenterName, getReferencelabel, routeIsCurrentComponent } from '@/mixins/utils';

export default {
  components: {
    Carousel,
    Slide,
    Pagination,
    Modal
  },
  setup () {
    const route = useRoute();
    const store = useStore();
    const selectedQRCode = ref('');
    const showModal = ref(false);
    provide('showModal', showModal);

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const actions = computed(() => menuHandler(route.name));
    const wallets = computed(() => store.state.wallets);
    function openModal (qrCode) {
      selectedQRCode.value = generateQRcode(qrCode);
      showModal.value = true;
    }
    return { actions, route, wallets, showModal, openModal, generateQRcode, selectedQRCode, getCenterName, getReferencelabel, routeMatchesComponent };
  }
};
</script>

<style lang="scss">

.carousel__pagination-button {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  border: 2px solid black;
  background-color: #e6ecf2;
}
.carousel__pagination-button--active {
  background-color: black;
}

.square-mobile {
  width: 70%;
}

.square-desktop {
  width: 12vw;
}

.square-mobile:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}
.square-desktop:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

@media (max-width: 1500px) {
  .square-desktop {
    width: 45%;
  }
}

@media (min-width: 479px) {
  .square-mobile {
    width: 50%;
  }
}
</style>
